import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
export var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      feedbackText = _ref.feedbackText,
      feedbackTextProps = _ref.feedbackTextProps,
      helperText = _ref.helperText,
      helperTextProps = _ref.helperTextProps,
      rest = _objectWithoutProperties(_ref, ["className", "feedbackText", "feedbackTextProps", "helperText", "helperTextProps"]);

  return React.createElement("div", _objectSpread({
    className: cx('tds-form-feedback', className)
  }, rest), React.createElement("div", _objectSpread({
    className: "tds-form-helper-text"
  }, helperTextProps), helperText), React.createElement("div", _objectSpread({
    className: "tds-form-feedback-text"
  }, feedbackTextProps), feedbackText));
};